import React from 'react';
import { useEffect, useState } from "react"
import { Button } from "../button"
import './scheduleMini.css';

export const ScheduleMini = ({initialValue = {}, onChange = () => {}, className}) => {

    const [value, setValue] = useState({
        monday: !!initialValue.monday,
        tuesday: !!initialValue.tuesday,
        wednesday: !!initialValue.wednesday,
        thursday: !!initialValue.thursday,
        friday: !!initialValue.friday
    });

    useEffect(() => {
        onChange(value);
    }, [value]);

    return <div className={'schedule-mini-input'}>
        <Button 
            className={(value.monday ? 'primary': '') + ' ' + className}
            type='button'
            title='Monday'
            onClick={() => {
                value.monday = !value.monday;
                setValue({...value});
            }}
        >M</Button>
        <Button 
            className={(value.tuesday ? 'primary': '') + ' ' + className}
            type='button'
            title='Tuesday'
            onClick={() => {
                value.tuesday = !value.tuesday;
                setValue({...value});
            }}
        >T</Button>
        <Button 
            className={(value.wednesday ? 'primary': '') + ' ' + className}
            type='button'
            title='Wednesday'
            onClick={() => {
                value.wednesday = !value.wednesday;
                setValue({...value});
            }}
        >W</Button>
        <Button 
            className={(value.thursday ? 'primary': '') + ' ' + className}
            type='button'
            title='Thursday'
            onClick={() => {
                value.thursday = !value.thursday;
                setValue({...value});
            }}
        >TH</Button>
        <Button 
            className={(value.friday ? 'primary': '') + ' ' + className}
            type='button'
            title='Friday'
            onClick={() => {
                value.friday = !value.friday;
                setValue({...value});
            }}
        >F</Button>
    </div>
}